









































import {
  defineComponent, useContext,
} from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";

export default defineComponent({
  name: 'PalmersClub',
  components: {
    StaticBlock: () => import(/* webpackMode: "lazy" */ '~/components/Palmers/BaseComponents/Cms/StaticBlock.vue'),
    PictureItem
  },
  props: {
    palmersClubList: {
      type: [Object, Boolean],
      require: true
    },
    palmersClubText: {
      type: [Object, Boolean],
      require: true
    },
    caption: {
      type: Object,
      require: true
    },
  },
  setup() {
    const {$vsf, $config} = useContext();

    return {
      magentoBaseUrl: $vsf.$magento.config.magentoBaseUrl,
      magentoMediaUrl: $config.magentoMediaUrl
    }
  },
  methods: {
    getSource() {
      if(this.source === 'default') {
        return this.magentoBaseUrl;
      }else {
        return this.magentoMediaUrl;
      }
    }
  }
});
